import {
  Button as UIButton,
  ClickAwayListener,
  MenuList,
  Popper,
  MenuItem,
  Paper,
  Grow,
} from "@mui/material";
import { useRef, useState } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import More2FillIcon from "remixicon-react/More2FillIcon";
import JTooltip from "$components/JTooltip/JTooltip";
import { EDB_IS_DISABLED_MSG } from "./constants";
import { theme } from "$utils/theme/bataillog";

type Props = {
  isAnIntegratedProduct: boolean;
  isDisabled: boolean;
  isProductDeletable: boolean;
  onAddToOp: () => void;
  onDeleteFromEdb: () => void;
  onUntrackIntegratedProduct: () => void;
  onSubstitute: () => void;
  opList?: any[];
};

function PopperButtons({
  isAnIntegratedProduct,
  isDisabled,
  isProductDeletable,
  onAddToOp,
  onDeleteFromEdb,
  onSubstitute,
  onUntrackIntegratedProduct,
  opList = [],
}: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const substitute = () => {
    handleClose();
    onSubstitute();
  };

  const addToOp = () => {
    handleClose();
    onAddToOp();
  };

  const deleteFromEdb = () => {
    handleClose();
    onDeleteFromEdb();
  };

  const deleteIntegratedProductFromTracking = () => {
    handleClose();
    onUntrackIntegratedProduct();
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      handleClose();
    }
  }
  const classes = useStyles();

  const anchor = useRef<HTMLDivElement>(null);
  return (
    <div ref={anchor}>
      <JTooltip title={isDisabled && EDB_IS_DISABLED_MSG}>
        <UIButton
          onClick={handleToggle}
          style={{ minWidth: 25 }}
          disabled={isDisabled}
          sx={{
            backgroundColor: "transparent !important",
            border: "none !important",
            color: "black !important",
            "&:hover": {
              backgroundColor: `${theme.color.gray1} !important`, // light gray hover
            },
            "&:focus": {
              backgroundColor: `${theme.color.gray1} !important`,
            },
          }}
        >
          <More2FillIcon />
        </UIButton>
      </JTooltip>
      <Popper
        open={open}
        anchorEl={anchor.current}
        placement="bottom-end"
        transition
        style={{ zIndex: 2 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                  style={{ padding: 0 }}
                >
                  <MenuItem
                    disabled={!isProductDeletable || isAnIntegratedProduct}
                    className={classes.popperBtn}
                    onClick={substitute}
                  >
                    Substituer
                  </MenuItem>
                  {opList.length > 0 && (
                    <MenuItem className={classes.popperBtn} onClick={addToOp}>
                      Ajouter à un OP
                    </MenuItem>
                  )}
                  {isAnIntegratedProduct && (
                    <MenuItem
                      disabled={!isProductDeletable}
                      className={classes.popperBtn}
                      onClick={deleteIntegratedProductFromTracking}
                    >
                      Retirer du suivi
                    </MenuItem>
                  )}
                  {!isAnIntegratedProduct && (
                    <MenuItem
                      disabled={!isProductDeletable}
                      className={classes.popperBtn}
                      onClick={deleteFromEdb}
                    >
                      Supprimer de l&apos;EDB
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

export default PopperButtons;

const useStyles = createUseStyles(() => ({
  popperBtn: {
    fontWeight: "bold !important",
  },
}));
